export const transactions = [
  {
    "id": 1,
    "cardId": 1,
    "merchant": "The Warehouse",
    "method": "Online",
    "date": "28/03/2025",
    "amount": "$17.92",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 2,
    "cardId": 2,
    "merchant": "New World",
    "method": "EFTPOS",
    "date": "04/02/2025",
    "amount": "$471.10",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 3,
    "cardId": 2,
    "merchant": "Bunnings",
    "method": "Apple Pay",
    "date": "18/02/2025",
    "amount": "$266.45",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 4,
    "cardId": 3,
    "merchant": "Kmart",
    "method": "Card Payment",
    "date": "30/03/2025",
    "amount": "$274.86",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 5,
    "cardId": 3,
    "merchant": "Countdown",
    "method": "Apple Pay",
    "date": "04/05/2025",
    "amount": "$53.29",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 6,
    "cardId": 3,
    "merchant": "Z Energy",
    "method": "EFTPOS",
    "date": "28/06/2025",
    "amount": "$426.10",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 7,
    "cardId": 3,
    "merchant": "Mobil Fuel",
    "method": "Visa",
    "date": "16/02/2025",
    "amount": "$332.96",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 8,
    "cardId": 4,
    "merchant": "Z Energy",
    "method": "Apple Pay",
    "date": "05/04/2025",
    "amount": "$349.47",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 9,
    "cardId": 4,
    "merchant": "Mocka New Zealand",
    "method": "Card Payment",
    "date": "08/02/2025",
    "amount": "$163.52",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 10,
    "cardId": 4,
    "merchant": "Amazon NZ",
    "method": "Online",
    "date": "17/05/2025",
    "amount": "$45.43",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 11,
    "cardId": 4,
    "merchant": "Starbucks NZ",
    "method": "Visa",
    "date": "06/03/2025",
    "amount": "$366.07",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 12,
    "cardId": 5,
    "merchant": "JB Hi-Fi",
    "method": "EFTPOS",
    "date": "30/04/2025",
    "amount": "$22.94",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 13,
    "cardId": 5,
    "merchant": "Mocka New Zealand",
    "method": "Visa",
    "date": "08/05/2025",
    "amount": "$113.74",
    "stampreward": "2",
    "valuetoget1reward": 50
  },
  {
    "id": 14,
    "cardId": 5,
    "merchant": "Domino's Pizza",
    "method": "Visa",
    "date": "12/04/2025",
    "amount": "$135.52",
    "stampreward": "2",
    "valuetoget1reward": 50
  },
  {
    "id": 15,
    "cardId": 5,
    "merchant": "The Warehouse",
    "method": "Mastercard",
    "date": "27/03/2025",
    "amount": "$36.35",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 16,
    "cardId": 6,
    "merchant": "Amazon NZ",
    "method": "Apple Pay",
    "date": "03/03/2025",
    "amount": "$431.00",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 17,
    "cardId": 6,
    "merchant": "Countdown",
    "method": "EFTPOS",
    "date": "20/01/2025",
    "amount": "$127.60",
    "stampreward": "2",
    "valuetoget1reward": 50
  },
  {
    "id": 18,
    "cardId": 6,
    "merchant": "Smiths City",
    "method": "Apple Pay",
    "date": "27/06/2025",
    "amount": "$449.82",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 19,
    "cardId": 6,
    "merchant": "New World",
    "method": "EFTPOS",
    "date": "18/06/2025",
    "amount": "$467.92",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 20,
    "cardId": 6,
    "merchant": "Smiths City",
    "method": "Visa",
    "date": "03/06/2025",
    "amount": "$27.30",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 21,
    "cardId": 7,
    "merchant": "McDonald's",
    "method": "Visa",
    "date": "07/05/2025",
    "amount": "$37.00",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 22,
    "cardId": 8,
    "merchant": "Pak'nSave",
    "method": "EFTPOS",
    "date": "25/02/2025",
    "amount": "$90.30",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 23,
    "cardId": 8,
    "merchant": "Td Chc Showroom",
    "method": "EFTPOS",
    "date": "19/03/2025",
    "amount": "$485.80",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 24,
    "cardId": 8,
    "merchant": "Chemist Warehouse",
    "method": "Mastercard",
    "date": "20/02/2025",
    "amount": "$267.02",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 25,
    "cardId": 8,
    "merchant": "Briscoes",
    "method": "EFTPOS",
    "date": "22/06/2025",
    "amount": "$459.28",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 26,
    "cardId": 8,
    "merchant": "Amazon NZ",
    "method": "Online",
    "date": "26/01/2025",
    "amount": "$258.39",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 27,
    "cardId": 9,
    "merchant": "PD Mart",
    "method": "EFTPOS",
    "date": "21/02/2025",
    "amount": "$393.31",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 28,
    "cardId": 9,
    "merchant": "Domino's Pizza",
    "method": "Card Payment",
    "date": "26/03/2025",
    "amount": "$384.02",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 29,
    "cardId": 9,
    "merchant": "Z Energy",
    "method": "Online",
    "date": "21/04/2025",
    "amount": "$284.78",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 30,
    "cardId": 10,
    "merchant": "Rebel Sport",
    "method": "Mastercard",
    "date": "08/01/2025",
    "amount": "$449.06",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 31,
    "cardId": 10,
    "merchant": "Domino's Pizza",
    "method": "Online",
    "date": "10/04/2025",
    "amount": "$351.74",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 32,
    "cardId": 10,
    "merchant": "Rebel Sport",
    "method": "Mastercard",
    "date": "04/01/2025",
    "amount": "$438.52",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 33,
    "cardId": 10,
    "merchant": "Countdown",
    "method": "Apple Pay",
    "date": "10/02/2025",
    "amount": "$402.21",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 34,
    "cardId": 11,
    "merchant": "Bunnings",
    "method": "Visa",
    "date": "18/02/2025",
    "amount": "$214.35",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 35,
    "cardId": 11,
    "merchant": "Td Chc Showroom",
    "method": "Card Payment",
    "date": "09/03/2025",
    "amount": "$253.27",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 36,
    "cardId": 11,
    "merchant": "Kmart",
    "method": "Visa",
    "date": "29/06/2025",
    "amount": "$240.99",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 37,
    "cardId": 11,
    "merchant": "Pak'nSave",
    "method": "Apple Pay",
    "date": "20/02/2025",
    "amount": "$403.95",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 38,
    "cardId": 12,
    "merchant": "Noel Leeming",
    "method": "Mastercard",
    "date": "12/01/2025",
    "amount": "$169.52",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 39,
    "cardId": 13,
    "merchant": "Burger King",
    "method": "Online",
    "date": "03/04/2025",
    "amount": "$269.90",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 40,
    "cardId": 13,
    "merchant": "BP Station",
    "method": "Apple Pay",
    "date": "23/01/2025",
    "amount": "$43.45",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 41,
    "cardId": 13,
    "merchant": "Noel Leeming",
    "method": "Card Payment",
    "date": "23/02/2025",
    "amount": "$339.27",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 42,
    "cardId": 13,
    "merchant": "Kmart",
    "method": "EFTPOS",
    "date": "17/06/2025",
    "amount": "$443.25",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 43,
    "cardId": 13,
    "merchant": "Z Energy",
    "method": "Mastercard",
    "date": "03/02/2025",
    "amount": "$20.82",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 44,
    "cardId": 14,
    "merchant": "BP Station",
    "method": "Mastercard",
    "date": "02/03/2025",
    "amount": "$45.48",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 45,
    "cardId": 15,
    "merchant": "Domino's Pizza",
    "method": "Apple Pay",
    "date": "17/01/2025",
    "amount": "$273.97",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 46,
    "cardId": 15,
    "merchant": "Smiths City",
    "method": "Card Payment",
    "date": "01/06/2025",
    "amount": "$69.33",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 47,
    "cardId": 16,
    "merchant": "Countdown",
    "method": "Visa",
    "date": "13/01/2025",
    "amount": "$315.73",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 48,
    "cardId": 16,
    "merchant": "Pak'nSave",
    "method": "Card Payment",
    "date": "28/01/2025",
    "amount": "$454.86",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 49,
    "cardId": 17,
    "merchant": "BP Station",
    "method": "Apple Pay",
    "date": "28/03/2025",
    "amount": "$124.53",
    "stampreward": "2",
    "valuetoget1reward": 50
  },
  {
    "id": 50,
    "cardId": 17,
    "merchant": "Td Chc Showroom",
    "method": "Apple Pay",
    "date": "11/06/2025",
    "amount": "$66.61",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 51,
    "cardId": 17,
    "merchant": "Kmart",
    "method": "Mastercard",
    "date": "08/04/2025",
    "amount": "$395.11",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 52,
    "cardId": 17,
    "merchant": "PD Mart",
    "method": "Card Payment",
    "date": "05/01/2025",
    "amount": "$119.06",
    "stampreward": "2",
    "valuetoget1reward": 50
  },
  {
    "id": 53,
    "cardId": 17,
    "merchant": "Td Chc Showroom",
    "method": "Apple Pay",
    "date": "09/03/2025",
    "amount": "$178.69",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 54,
    "cardId": 18,
    "merchant": "New World",
    "method": "Apple Pay",
    "date": "31/01/2025",
    "amount": "$280.82",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 55,
    "cardId": 18,
    "merchant": "New World",
    "method": "Apple Pay",
    "date": "03/05/2025",
    "amount": "$84.86",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 56,
    "cardId": 18,
    "merchant": "Td Chc Showroom",
    "method": "Mastercard",
    "date": "12/04/2025",
    "amount": "$69.48",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 57,
    "cardId": 18,
    "merchant": "Countdown",
    "method": "Card Payment",
    "date": "14/03/2025",
    "amount": "$69.34",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 58,
    "cardId": 19,
    "merchant": "JB Hi-Fi",
    "method": "EFTPOS",
    "date": "15/03/2025",
    "amount": "$268.96",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 59,
    "cardId": 20,
    "merchant": "Farmers",
    "method": "Mastercard",
    "date": "10/02/2025",
    "amount": "$49.94",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 60,
    "cardId": 20,
    "merchant": "Chemist Warehouse",
    "method": "EFTPOS",
    "date": "16/06/2025",
    "amount": "$33.83",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 61,
    "cardId": 20,
    "merchant": "BP Station",
    "method": "Card Payment",
    "date": "12/03/2025",
    "amount": "$52.54",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 62,
    "cardId": 20,
    "merchant": "JB Hi-Fi",
    "method": "Apple Pay",
    "date": "17/06/2025",
    "amount": "$241.17",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 63,
    "cardId": 21,
    "merchant": "Mobil Fuel",
    "method": "Visa",
    "date": "25/04/2025",
    "amount": "$469.61",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 64,
    "cardId": 21,
    "merchant": "Domino's Pizza",
    "method": "EFTPOS",
    "date": "20/02/2025",
    "amount": "$290.86",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 65,
    "cardId": 21,
    "merchant": "Chemist Warehouse",
    "method": "Apple Pay",
    "date": "28/01/2025",
    "amount": "$308.61",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 66,
    "cardId": 21,
    "merchant": "Mocka New Zealand",
    "method": "Online",
    "date": "12/02/2025",
    "amount": "$167.24",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 67,
    "cardId": 21,
    "merchant": "Briscoes",
    "method": "Apple Pay",
    "date": "15/02/2025",
    "amount": "$462.79",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 68,
    "cardId": 22,
    "merchant": "Domino's Pizza",
    "method": "Visa",
    "date": "05/01/2025",
    "amount": "$314.82",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 69,
    "cardId": 22,
    "merchant": "Countdown",
    "method": "Visa",
    "date": "27/02/2025",
    "amount": "$434.02",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 70,
    "cardId": 22,
    "merchant": "Amazon NZ",
    "method": "Visa",
    "date": "15/06/2025",
    "amount": "$385.99",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 71,
    "cardId": 23,
    "merchant": "Kmart",
    "method": "Apple Pay",
    "date": "04/02/2025",
    "amount": "$403.84",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 72,
    "cardId": 23,
    "merchant": "JB Hi-Fi",
    "method": "EFTPOS",
    "date": "25/01/2025",
    "amount": "$270.61",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 73,
    "cardId": 23,
    "merchant": "New World",
    "method": "EFTPOS",
    "date": "10/01/2025",
    "amount": "$11.53",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 74,
    "cardId": 23,
    "merchant": "Briscoes",
    "method": "EFTPOS",
    "date": "23/05/2025",
    "amount": "$22.83",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 75,
    "cardId": 23,
    "merchant": "Amazon NZ",
    "method": "Apple Pay",
    "date": "17/06/2025",
    "amount": "$417.85",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 76,
    "cardId": 24,
    "merchant": "JB Hi-Fi",
    "method": "Card Payment",
    "date": "21/01/2025",
    "amount": "$468.09",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 77,
    "cardId": 24,
    "merchant": "Briscoes",
    "method": "EFTPOS",
    "date": "07/05/2025",
    "amount": "$313.79",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 78,
    "cardId": 24,
    "merchant": "New World",
    "method": "Online",
    "date": "23/06/2025",
    "amount": "$141.59",
    "stampreward": "2",
    "valuetoget1reward": 50
  },
  {
    "id": 79,
    "cardId": 25,
    "merchant": "BP Station",
    "method": "EFTPOS",
    "date": "27/06/2025",
    "amount": "$178.56",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 80,
    "cardId": 25,
    "merchant": "Rebel Sport",
    "method": "Visa",
    "date": "26/05/2025",
    "amount": "$398.06",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 81,
    "cardId": 25,
    "merchant": "PD Mart",
    "method": "Card Payment",
    "date": "02/04/2025",
    "amount": "$244.71",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 82,
    "cardId": 26,
    "merchant": "Noel Leeming",
    "method": "Mastercard",
    "date": "15/04/2025",
    "amount": "$254.99",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 83,
    "cardId": 26,
    "merchant": "Smiths City",
    "method": "Apple Pay",
    "date": "07/05/2025",
    "amount": "$368.60",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 84,
    "cardId": 26,
    "merchant": "Farmers",
    "method": "Apple Pay",
    "date": "25/02/2025",
    "amount": "$345.34",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 85,
    "cardId": 27,
    "merchant": "Countdown",
    "method": "Card Payment",
    "date": "30/01/2025",
    "amount": "$413.98",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 86,
    "cardId": 27,
    "merchant": "McDonald's",
    "method": "Visa",
    "date": "27/05/2025",
    "amount": "$242.18",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 87,
    "cardId": 27,
    "merchant": "BP Station",
    "method": "Visa",
    "date": "25/02/2025",
    "amount": "$170.16",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 88,
    "cardId": 27,
    "merchant": "Countdown",
    "method": "EFTPOS",
    "date": "13/04/2025",
    "amount": "$187.07",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 89,
    "cardId": 28,
    "merchant": "Mobil Fuel",
    "method": "Apple Pay",
    "date": "29/04/2025",
    "amount": "$167.87",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 90,
    "cardId": 28,
    "merchant": "The Warehouse",
    "method": "Mastercard",
    "date": "10/03/2025",
    "amount": "$324.61",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 91,
    "cardId": 28,
    "merchant": "Countdown",
    "method": "Apple Pay",
    "date": "08/06/2025",
    "amount": "$495.22",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 92,
    "cardId": 28,
    "merchant": "Smiths City",
    "method": "Card Payment",
    "date": "06/05/2025",
    "amount": "$448.20",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 93,
    "cardId": 29,
    "merchant": "Countdown",
    "method": "Card Payment",
    "date": "17/04/2025",
    "amount": "$76.32",
    "stampreward": "1",
    "valuetoget1reward": 50
  },
  {
    "id": 94,
    "cardId": 29,
    "merchant": "BP Station",
    "method": "Mastercard",
    "date": "26/03/2025",
    "amount": "$110.64",
    "stampreward": "2",
    "valuetoget1reward": 50
  },
  {
    "id": 95,
    "cardId": 29,
    "merchant": "Z Energy",
    "method": "Mastercard",
    "date": "09/01/2025",
    "amount": "$11.05",
    "stampreward": "0",
    "valuetoget1reward": 50
  },
  {
    "id": 96,
    "cardId": 29,
    "merchant": "New World",
    "method": "Online",
    "date": "26/06/2025",
    "amount": "$304.27",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 97,
    "cardId": 29,
    "merchant": "Countdown",
    "method": "Visa",
    "date": "28/06/2025",
    "amount": "$448.29",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 98,
    "cardId": 30,
    "merchant": "Amazon NZ",
    "method": "Card Payment",
    "date": "11/02/2025",
    "amount": "$371.75",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 99,
    "cardId": 30,
    "merchant": "Countdown",
    "method": "Card Payment",
    "date": "28/02/2025",
    "amount": "$441.09",
    "stampreward": "3",
    "valuetoget1reward": 50
  },
  {
    "id": 100,
    "cardId": 30,
    "merchant": "Noel Leeming",
    "method": "Online",
    "date": "23/06/2025",
    "amount": "$140.21",
    "stampreward": "2",
    "valuetoget1reward": 50
  }
]